import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@mui/material';
import Iconify from 'src/components/Iconify';
import { useCanTransferLead } from 'src/hooks/useHasMultiplePractices';

export const TRANSFER_MENU_ITEM_SX = { whiteSpace: 'normal', lineHeight: 1.3, py: 0.75 };
export const TRANSFER_ICON_SX = { flexShrink: 0 };

// Row-menu entry for moving a lead to another practice. Renders nothing unless the
// user has access to more than one practice, the lead is not archived (or archiving),
// and the host table supplied a handler (some tables have no transfer dialog mounted).
const TransferLeadMenuItem = ({ params, handleTransferLead }) => {
    const row = params?.row;
    const canTransfer = useCanTransferLead(row);
    if (!canTransfer || !handleTransferLead) return null;
    return (
        // The row menu is a fixed-width paper: let the label wrap and keep the icon at full size.
        <MenuItem onClick={() => handleTransferLead(row)} sx={TRANSFER_MENU_ITEM_SX}>
            <Iconify icon={'eva:swap-fill'} sx={TRANSFER_ICON_SX} />
            Transfer to another practice
        </MenuItem>
    );
};

export default TransferLeadMenuItem;

TransferLeadMenuItem.propTypes = {
    params: PropTypes.object,
    handleTransferLead: PropTypes.func,
};
